(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["fh-basic-energy-collection"]) return;
  try {
    
  function updateEnergyPreviewLinks() {
    const preview = new URLSearchParams(window.location.search).get('fh_energy_return') === 'preview';
    document.querySelectorAll('[data-fh-energy-back]').forEach((link) => {
      link.setAttribute('href', preview ? '/pages/pokedex?view=basic-energy' : '/pages/basic-energy-cards');
    });
    if (!preview) return;
    document.querySelectorAll('a[href*="view=basic-energy-"], #facet-filters a[href]').forEach((link) => {
      const url = new URL(link.href, window.location.href);
      if (url.origin !== window.location.origin || url.pathname !== window.location.pathname) return;
      url.searchParams.set('fh_energy_return', 'preview');
      link.setAttribute('href', url.pathname + url.search + url.hash);
    });
  }
  updateEnergyPreviewLinks();
  window.addEventListener('popstate', updateEnergyPreviewLinks);
  const energyProducts = document.querySelector('.cc-collection-products');
  if (energyProducts && document.querySelector('[data-fh-energy-back]')) {
    new MutationObserver(updateEnergyPreviewLinks).observe(energyProducts, { childList: true, subtree: true });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  customElements.whenDefined('details-disclosure').then(() => {
    class FooterMenu extends DetailsDisclosure {
      constructor() {
        super();
        this.reset(false);
        window.addEventListener('on:breakpoint-change', this.reset.bind(this));
      }

      reset() {
        const isLargeScreen = window.matchMedia(theme.mediaQueries.md).matches;
        const isConfirmNewsletter = !isLargeScreen &&
          (window.location.hash === "#footer-signup_form" && this.querySelector('#footer-signup_form') !== null);

        this.disclosure.open = isLargeScreen || isConfirmNewsletter;

        if (isLargeScreen) {
          this.toggle.setAttribute('tabindex', '-1');
        } else {
          this.toggle.removeAttribute('tabindex');
        }
      }
    }

    customElements.define('footer-menu', FooterMenu);
  });

  } catch(e) { console.error(e); }
})();
})();
